import { useAuth } from '../../lib/contexts/AuthContext';
import { RoleBadge } from '@/components/ui/role-badge';

/**
 * Story 24.7 — the account identity block shared by the desktop AvatarMenu
 * and the phone More page (DESIGN.md › AvatarMenu): tenant name, the person's
 * name, then one role badge. The Theme control is its own component
 * (`ThemeControl`, Story 25.8), placed after this block by both hosts.
 *
 * Story 24.24b — the badge is the shared `RoleBadge` (sentence case through
 * `normalizeRole`, never the raw slug), the same one the settings pages show.
 */
export default function AccountIdentity({ className }: { className?: string }) {
  const { user, tenant } = useAuth();
  return (
    <div className={className} data-testid="account-identity">
      {tenant && <p className="type-caption text-ink-muted break-words">{tenant.name}</p>}
      <p className="type-label text-ink break-words">{user?.name || 'User'}</p>
      {user?.role && <RoleBadge role={user.role} className="mt-1" />}
    </div>
  );
}
